import React from "react";
import { MemoriesList } from "../features/memory/components/MemoriesList";
import { useFavoriteMemories } from "../features/memory/hooks/useFavoriteMemories";

export const FavoriteMemoriesPage: React.FC = () => {
    const {
        memories,
        isMemoriesLoading,
        incrementLikedCount,
        tempLikedMemoryIds,
    } = useFavoriteMemories();
    return (
        <MemoriesList
            memories={memories}
            isLoading={isMemoriesLoading}
            emptyMessage="まだお気に入り登録した記憶はありません。"
            incrementLikedCount={incrementLikedCount}
            tempLikedMemoryIds={tempLikedMemoryIds}
        />
    );
};
